import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import { GrPowerReset } from "react-icons/gr";
import OtpInput from "react-otp-input";
import { signUp,sendOtp } from "../services/operations/authAPI";

function VerifyEmail(props) {
  const { loading,signupData } = useSelector((state) => state.auth);
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // useEffect(()=>{
  //   if(!signupData)
  //   {
  //       navigate("/signup"); // incase if value is not present about the user
  //   }
  // },[])

  function handleOnSubmit(e) {
    e.preventDefault();

    const {accountType,
        firstName,
        lastName,
        email,
        password,
        confirmPassword,
    } = signupData;

    dispatch(signUp(accountType,
        firstName,
        lastName,
        email,
        password,
        confirmPassword,otp,navigate));
  }

  // function onClickSendOtp(e)
  // {
  //   dispatch(sendOtp(signupData.email,navigate));
  // }
  return (
    <div className="flex w-full justify-center items-center">
    <div className="w-[50%] mt-[10rem] flex flex-col justify-center items-center">
        {loading ? (
          <div className='flex w-full h-screen justify-center items-center'>
            <div class="spinner"></div>
          </div>
        ) : (
          <div className="">
            <div className="text-3xl text-richblack-25 font-semibold">
              <h1>Verify email</h1>
            </div>
            <div>
              <p className="text-richblack-100 text-md mt-1">
                A verification code has been sent to you. Enter the code below
              </p>
            </div>
            <form className="mt-4 flex flex-col justify-center items-center " onSubmit={handleOnSubmit}>
              
              <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                renderSeparator={<span>-</span>}
                renderInput={(props) => (
                  <input
                    {...props}
                    placeholder="-"
                    style={{
                      boxShadow: "inset 0px -1px 0px rgba(255, 255, 255, 0.18)",
                    }}
                    className="w-[48px] lg:w-[60px] border-0 bg-richblack-800 rounded-[0.5rem] text-richblack-5 aspect-square text-center focus:border-0 focus:outline-2 focus:outline-yellow-50"
                  />
                )}
                // renderInput={(props) => (<input {...props}
                // placeholder='-'
                // />)
                containerStyle={{
                  justifyContent: "space-between",
                  gap: "0 6px",
                }}
              />
              <button
                type="submit"
                className="text-center w-full text-[13px] px-6 py-3 rounded-md font-bold 
              bg-yellow-50
              hover:scale-95 transition-all duration-200 mt-2">
                Verify email
              </button>
            </form>
            <div className="flex w-full mt-4 justify-between items-center">
              <div className="text-richblack-25 hover:text-richblack-50 transition-all duration-200">
                <Link to="/login" className="flex items-center gap-x-2">
                  <FaArrowLeft /> <p>Back to Login</p>
                </Link>
              </div>
              <div className="flex items-center gap-x-2 cursor-pointer hover:text-blue-400 text-blue-200 transition-all duration-200">
                <GrPowerReset />
                <p onClick={() => dispatch(sendOtp(signupData.email,navigate))}>Resend it</p>
              </div>
            </div>
          </div>
        )}
      </div>
      </div>
  );
}

export default VerifyEmail;